<span class="timer">
    @if (showHours) {
        <span>{{ displayTime.hours }}:</span>
    }
    @if (showMinutes) {
        <span>{{ displayTime.minutes }}:</span>
    }
    @if (showSeconds) {
        <span>{{ displayTime.seconds }}</span>
    }
    @if (showMilliseconds) {
        <span>:{{ displayTime.milliseconds }}</span>
    }
</span>
